export type PaymentProductType = 'subscription' | 'topup';

export interface PaymentProduct {
  id: string;
  name: string;
  type: PaymentProductType;
  price: number;
  tagline: string;
  description: string;
  tokens?: number;
  features: string[];
}

export const PAYMENT_PRODUCTS: Record<string, PaymentProduct> = {
  lynmet: {
    id: 'lynmet',
    name: 'Plan LynMet',
    type: 'subscription',
    price: 9900,
    tagline: 'Más tokens. Más continuidad. Menos fricción.',
    description: 'Suscripción mensual con recarga continua para acompañar el avance del negocio.',
    tokens: 100,
    features: [
      'Todo lo del Plan Gratuito',
      '100 tokens al activar el plan',
      'Recarga mensual hasta 100 tokens si tu saldo baja de 100',
      '+20 tokens semanales si tu saldo llega a 5 o menos',
      'Prioridad para nuevas funciones',
    ],
  },
  topup_80: {
    id: 'topup_80',
    name: 'Recarga de tokens',
    type: 'topup',
    price: 2900,
    tagline: 'Impulso extra para seguir hoy mismo.',
    description: 'Recarga manual de 80 tokens para usar de inmediato en LynMet.',
    tokens: 80,
    features: [
      '+80 tokens acreditados en tu cuenta',
      'Ideal para cerrar 2 procesos completos o iterar entre mentores sin fricción',
    ],
  },
};

export function getPaymentProduct(productId: string) {
  return PAYMENT_PRODUCTS[productId] ?? null;
}
